// extracted by mini-css-extract-plugin
module.exports = {"mobileNavItems":"styles_mobileNavItems__lLD_P","mobileNavItemsOpen":"styles_mobileNavItemsOpen__GfaVt"};